module.exports = __webpack_public_path__ + "static/media/Gotham-Thin.38253acb.ttf";